
import { defineComponent, computed } from 'vue'
import { dateToString } from '@/services/date'
import JrInputView from '@/components/jr-parts/JrInputView.vue'
import DateDisplay from '@/components/displays/DateDisplay.vue'

export default defineComponent({
  name: 'JrDateRangePicker',
  emits: ['update:start', 'update:end'],
  components: {
    JrInputView,
    DateDisplay,
  },
  props: {
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    format: {
      type: String,
      required: false,
      default: 'YYYY年MM月DD日',
    },
    disabledDate: {
      type: Function,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props, context) {
    const value = computed(() => {
      return [props.start, props.end]
    })
    return {
      value,
      update: (dates: Array<Date> | null) => {
        let start = ''
        let end = ''
        if (dates != null && dates.length >= 1) {
          start = dateToString(dates[0])
        }
        if (dates != null && dates.length === 2) {
          end = dateToString(dates[1])
        }
        context.emit('update:start', start)
        context.emit('update:end', end)
      },
    }
  },
})
